export default class Share {
    constructor() {
        this.$share = document.querySelector(".js-howto4th-share");

        if (!this.$share) return;

        this.$x = this.$share.querySelector(".js-howto4th-share-x");
        this.$facebook = this.$share.querySelector(".js-howto4th-share-facebook");
        this.$line = this.$share.querySelector(".js-howto4th-share-line");
        this.setShareUrls();
    }

    setShareUrls() {
        const title = document.title;
        const url = window.location.href;
        const xParams = new URLSearchParams({ text: title, url });
        const facebookParams = new URLSearchParams({ u: url });
        const lineParams = new URLSearchParams({ url, text: title });

        this.enableLink(this.$x, `https://twitter.com/intent/tweet?${xParams.toString()}`);
        this.enableLink(this.$facebook, `https://www.facebook.com/sharer/sharer.php?${facebookParams.toString()}`);
        this.enableLink(this.$line, `https://social-plugins.line.me/lineit/share?${lineParams.toString()}`);
    }

    enableLink($link, url) {
        $link.href = url;
        $link.removeAttribute("aria-disabled");
    }
}
